var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSleep28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4916 18.9902C19.8774 21.4081 17.1232 23 14 23C9.02944 23 5 18.9706 5 14C5 10.8768 6.59193 8.12259 9.00976 6.50843C9.27032 13.2838 14.7162 18.7297 21.4916 18.9902ZM22.4923 16.9892C22.3291 16.9964 22.165 17 22 17C15.9249 17 11 12.0751 11 6C11 5.83503 11.0036 5.6709 11.0108 5.5077C11.0438 4.75893 11.1516 4.0296 11.327 3.32703C10.5609 3.51829 9.8265 3.78989 9.13342 4.13236C5.49935 5.92805 3 9.67215 3 14C3 20.0751 7.92487 25 14 25C18.3279 25 22.0719 22.5006 23.8676 18.8666C24.2101 18.1735 24.4817 17.4391 24.673 16.673C23.9704 16.8484 23.2411 16.9562 22.4923 16.9892Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSleep28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;